import 'angular-datacenter-loader';
import datacenterSheet from './datacenterSheet';

export default angular

  .module('datacenterServices', ['angularDatacenterLoader'])

  .service('datacenterSheet', datacenterSheet)

  .name;



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/services/services.js